import { createSelector } from "reselect";

const getChapterId = (_, ownProps) => ownProps.chapterId;
const getStory = (state) => state.story;

export const getChapterEntity = createSelector(
  getChapterId,
  getStory,
  (chapterId, story) => {
    if (!chapterId) {
      throw new Error(
        "Could not get chapter entity because no chapter id was passed",
      );
    }

    const chapterLink = story.chapters.find(
      (chapter) => chapter.id === chapterId,
    );
    if (!chapterLink) throw new Error("could not find chapter entity");
    return story.entities[chapterLink.schema][chapterLink.id];
  },
);

export const getOptionalChapterEntity = createSelector(
  getChapterId,
  getStory,
  (chapterId, story) => {
    if (!chapterId) {
      return null;
    }

    const chapterLink = story.chapters.find(
      (chapter) => chapter.id === chapterId,
    );
    if (!chapterLink) throw new Error("could not find chapter entity");
    return story.entities[chapterLink.schema][chapterLink.id];
  },
);

// This creates a new selector for each source that wants one. See the "Sharing Selectors Across
// Multiple Components" section of http://redux.js.org/docs/recipes/ComputingDerivedData.html
const makeGetChapterEntity = () => getChapterEntity;

export default makeGetChapterEntity;
